import styled from "styled-components";

export const WrapperGrid = styled.div`
  display: flex;
  padding: 20px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  strong{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 18px;
    margin:20px;
  }
  .section-button{
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    margin: 10px;
    margin-top: 40px;
  }
`